import { ErrorData } from "./error-data.model";

export class CustomResponse<T> {
    isSuccessful!: boolean;
    isFatal!: boolean;
    
    data: T;
    error: ErrorData;
}
